/// <reference path="../objects/classes/basecontroller.ts" />
/// <reference path="../services/composition.service.ts" />
/// <reference path="../objects/interfaces/iproduct.ts" />

module App.Controllers {
    export interface ITyreChangeController extends IBaseController {

    }

    export class TyreChangeController extends BaseController implements ITyreChangeController {
        static controllerId = 'tyrechangeController';

        static $inject = [
            '$rootScope',
            '$scope',
            '$q',
            '$stateParams',
            Services.SessionService.serviceId,
            Services.NavigationService.serviceId,
            Services.CompositionService.serviceId,
            'ngDialog',
            '$sce',
            Services.ValidationService.serviceId,
            Services.AccountService.serviceId,
            SnackbarFactory.factoryId
        ];
        
        constructor(public $rootScope: Interfaces.IAppRootScope,
            $scope: ng.IScope,
            $q: ng.IQService,
            $stateParams: ng.ui.IStateParamsService,
            sessionService: App.Interfaces.ISessionService,
            navigationService: App.Interfaces.INavigationService,
            composition: Interfaces.ICompositionService,
            ngDialog: any,
            $sce: any, 
            validationService: Interfaces.IValidationService, 
            accountService: Interfaces.IAccountService, 
            snackbarFactory: Interfaces.ISnackbarFactory) {
            super($rootScope, $scope, $q, sessionService, navigationService, composition, ngDialog, $sce, validationService, accountService, snackbarFactory);

            
        }

    }

    app.controller(TyreChangeController.controllerId, TyreChangeController);

}